"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StateStorage = /** @class */ (function () {
    function StateStorage(stateArgs) {
        this.STATE_POSTFIX_NAME = 'state';
        this.STATE_NAME = stateArgs.clientId + "_" + this.STATE_POSTFIX_NAME;
    }
    StateStorage.prototype.setState = function (state) {
        sessionStorage.setItem(this.STATE_NAME, state);
    };
    StateStorage.prototype.getState = function () {
        return sessionStorage.getItem(this.STATE_NAME);
    };
    StateStorage.prototype.clearState = function () {
        sessionStorage.removeItem(this.STATE_NAME);
    };
    return StateStorage;
}());
exports.StateStorage = StateStorage;
//# sourceMappingURL=state.js.map


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/lib/store/state.js